import { useEnv } from '@vs/utils/envConfig';

export type PropsPortalUiLottieLoading = {
  size?: number;
};

export function PortalUiLottieLoading({
  size = 25,
}: PropsPortalUiLottieLoading) {
  const env = useEnv();
  return (
    <img
      alt="loading"
      aria-hidden="true"
      src={`${env.assets.vs}/images/loading.gif`}
      style={{ width: size, height: size }}
    />
  );
}

export default PortalUiLottieLoading;
